var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_986_11881)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 0C11.7712 0 13.6566 0.000298959 14.8281 1.17188C15.9997 2.34344 16 4.22877 16 8C16 11.7712 15.9997 13.6566 14.8281 14.8281C13.6566 15.9997 11.7712 16 8 16C4.22877 16 2.34344 15.9997 1.17188 14.8281C0.000298959 13.6566 0 11.7712 0 8C0 4.22876 0.000298972 2.34344 1.17188 1.17188C2.34344 0.000298972 4.22876 0 8 0ZM5.93066 4.07031C3.75975 4.07052 2.00016 5.83006 2 8.00098C2 10.1721 3.75965 11.9324 5.93066 11.9326C8.1019 11.9326 9.8623 10.1722 9.8623 8.00098C9.86214 7.65831 9.58392 7.38086 9.24121 7.38086C8.89869 7.38108 8.62126 7.65844 8.62109 8.00098C8.62109 9.4865 7.4162 10.6914 5.93066 10.6914C4.44528 10.6912 3.24121 9.48637 3.24121 8.00098C3.24137 6.51572 4.44538 5.31173 5.93066 5.31152C6.27348 5.31152 6.55176 5.03325 6.55176 4.69043C6.5516 4.34775 6.27338 4.07031 5.93066 4.07031ZM10.0693 4.07031C7.8982 4.07031 6.13786 5.82993 6.1377 8.00098C6.1377 8.34378 6.41598 8.62207 6.75879 8.62207C7.10151 8.62197 7.37891 8.34372 7.37891 8.00098C7.37907 6.51559 8.5839 5.31152 10.0693 5.31152C11.5547 5.31161 12.7586 6.51564 12.7588 8.00098C12.7588 9.48645 11.5548 10.6913 10.0693 10.6914C9.72663 10.6914 9.44841 10.9689 9.44824 11.3115C9.44824 11.6543 9.72653 11.9326 10.0693 11.9326C12.2405 11.9325 14 10.1721 14 8.00098C13.9998 5.82999 12.2404 4.0704 10.0693 4.07031Z",
    fill: "#430A9C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_986_11881"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.d2425209c626c5119605b4fd5ebf4e46.svg";
export { ForwardRef as ReactComponent };